import { EDisplays, EJourneys, selectDisplay } from '@/context/display';
import { useAppSelector } from '@/context/storeHooks';
import { EParameters, getParameters } from '@/utils/setParametersFromParams';

import { Button, EButtonType } from '../Button';

interface IDisplayButtonsProps {
    leftClick: () => void; // Todo: Remove the optional
    rightClick: () => void; // Todo: Remove the optional
    leftText?: string;
    rightText?: string;
    leftType?: EButtonType;
    rightType?: EButtonType;
    idLeftButton?: string;
    idRightButton?: string;
}

export const testId = 'display-buttons';

function DisplayButtons({
    idLeftButton,
    idRightButton,
    leftClick,
    rightClick,
    leftText = 'Back',
    rightText = 'Next',
    leftType = EButtonType.SECONDARY_OUTLINE,
    rightType = EButtonType.PRIMARY,
}: IDisplayButtonsProps): JSX.Element {
    const params = getParameters();

    const paramJourney = params.get(EParameters.INITIAL_JOURNEY);
    const display = useAppSelector(selectDisplay);

    return (
        <div className='_flex w-full space-x-[25px] pt-2 pb-2 px-2 overflow-hidden'>
            {paramJourney?.toLocaleUpperCase() === EJourneys.TEST_DRIVE &&
            display === EDisplays.BASIC ? (
                <div></div>
            ) : (
                <Button onClick={leftClick} type={leftType} id={idLeftButton}>
                    <p className='text-xs'>{leftText}</p>
                </Button>
            )}
            <Button onClick={rightClick} type={rightType} id={idRightButton}>
                <p className='text-xs'> {rightText}</p>
            </Button>
        </div>
    );
}

export { DisplayButtons };
